var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C5.925 4 3 6.925 3 10.5C3 14.075 5.925 17 9.5 17C13.075 17 16 14.075 16 10.5C16 6.925 13.075 4 9.5 4Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8551 13.642C10.5294 13.772 9.40046 14.319 8.75 13.7375C8.55585 13.5645 8.45926 13.345 8.45926 13.0785C8.45926 12.5795 8.62089 12.1445 8.91212 11.1C8.96337 10.9025 9.02595 10.6465 9.02595 10.4435C9.02595 10.093 8.89487 10 8.53959 10C8.36613 10 8.17395 10.0625 8 10.1285L8.09609 9.72902C8.4839 9.56902 8.97076 9.37402 9.38765 9.37402C10.013 9.37402 10.4732 9.69052 10.4732 10.2925C10.4732 10.466 10.4437 10.77 10.3816 10.98L10.0218 12.271C9.94744 12.532 9.81291 13.1075 10.0214 13.278C10.2263 13.4465 10.7117 13.357 10.9512 13.2425L10.8551 13.642Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.74999C9 8.16399 9.336 8.49998 9.75 8.49998C10.164 8.49998 10.5 8.16399 10.5 7.74999C10.5 7.336 10.164 7 9.75 7C9.336 7 9 7.336 9 7.74999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.12c9db41.svg";
export { ForwardRef as ReactComponent };